function mapStagedItemModifiers(modifiers) {
  return modifiers.map(modifier => ({
    menuItemId: modifier.menuItemId,
    quantity: modifier.quantity,
    ...modifier.modifiers?.length > 0 && { modifiers: mapStagedItemModifiers(modifier.modifiers) }
  }));
}

export default mapStagedItemModifiers;
